import React from 'react';

function Footer() {
  const [result, setResult] = React.useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult('Sending....');
    const formData = new FormData(event.target);

    formData.append('access_key', '991ae112-f514-44dc-bb8d-f810f2b5b39d');

    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult('Thank you for subscribing!');
      event.target.reset();
    } else {
      console.log('Error', data);
      setResult(data.message);
    }
  };
  return (
    <div>
      <footer id="footer">
        <div class="footer-newsletter">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-6">
                <h4>Join Our Newsletter</h4>
                <p>
                  Subscribe to our newsletter for the latest updates, exclusive
                  discounts, and expert tips on web hosting, software licenses,
                  and cybersecurity.
                </p>
                <form
                  action="https://api.web3forms.com/submit"
                  method="POST"
                  class="php-email-form"
                  onSubmit={onSubmit}
                >
                  <input
                    type="hidden"
                    name="access_key"
                    value="991ae112-f514-44dc-bb8d-f810f2b5b39d"
                  />
                  <input type="email" name="email" />
                  <input
                    type="submit"
                    onclick="contactFormSubmit(); return false;"
                    value="Subscribe"
                  />
                </form>
                <br />
                <span>{result}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-top">
          <div class="container">
            <div class="row">
              <div class="col-lg-12 col-md-12 footer-contact">
                <h3>Softskart</h3>
                <p>
                  Enterprising Zone, Opposite Bihar Museum <br /> Near Jagat
                  Amravati Apartment, Bailey Road, Patna, Bihar - 800001
                  <br />
                  India <br />
                  <br />
                  <strong>Phone:</strong> +91 98608 11038
                  <br />
                  <strong>Email:</strong> contact@softskart.com
                  <br />
                </p>
              </div>

              {/* <div class="col-lg-4 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <div className="d-flex justify-content-center">
                  <ul>
                    <li>
                      <i class="bx bx-chevron-right"></i> <a href>Home</a>
                    </li>
                    <li>
                      <i class="bx bx-chevron-right"></i> <a href>About us</a>
                    </li>
                    <li>
                      <i class="bx bx-chevron-right"></i> <a href>Services</a>
                    </li>
                    <li>
                      <i class="bx bx-chevron-right"></i>{' '}
                      <a href>Terms of service</a>
                    </li>
                    <li>
                      <i class="bx bx-chevron-right"></i>{' '}
                      <a href>Privacy policy</a>
                    </li>
                  </ul>
                </div>
              </div> */}

              {/* <div class="col-lg-3 col-md-6 footer-links">
                <h4>Our Services</h4>
                <ul>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Corporate Advisory</a>
                  </li>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Startup Advisory</a>
                  </li>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Funding Presenation</a>
                  </li>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Loan Proposal</a>
                  </li>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Compliance Support</a>
                  </li>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Cloud Services</a>
                  </li>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Certifications</a>
                  </li>
                  <li>
                    <i class="bx bx-chevron-right"></i>{' '}
                    <a href>Expert Consultations</a>
                  </li>
                </ul>
              </div> */}

              {/* <div class="col-lg-4 col-md-6 footer-links">
                <h4>Our Social Networks</h4>
                <p>
                  Cras fermentum odio eu feugiat lide par naso tierra videa
                  magna derita valies
                </p>
                <div class="social-links mt-3">
                  <a href class="twitter">
                    <i class="bx bxl-twitter"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/profile.php?id=100066380695575"
                    class="facebook"
                  >
                    <i class="bx bxl-facebook"></i>
                  </a>
                  <a
                    href="https://instagram.com/pali.tronics?igshid=ZDdkNTZiNTM="
                    class="instagram"
                  >
                    <i class="bx bxl-instagram"></i>
                  </a>
                  <a href class="google-plus">
                    <i class="bx bxl-skype"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/77188296/admin/"
                    class="linkedin"
                  >
                    <i class="bx bxl-linkedin"></i>
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div class="container footer-bottom clearfix">
          <div class="copyright">
            &copy; Copyright{' '}
            <strong>
              <span>Softskart</span>
            </strong>
            . All Rights Reserved
          </div>
          <div class="credits">
            Designed by <a href="https://softskart.com/">Softskart</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
